import { render, staticRenderFns } from "./error-log-comment-save-modal.vue?vue&type=template&id=2c1fad72&scoped=true&"
import script from "./error-log-comment-save-modal.vue?vue&type=script&lang=js&"
export * from "./error-log-comment-save-modal.vue?vue&type=script&lang=js&"
import style0 from "./error-log-comment-save-modal.vue?vue&type=style&index=0&id=2c1fad72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1fad72",
  null
  
)

export default component.exports